import feedApi from '@/api/feed.js'

export const resetState = ({ commit }) => {
  commit('resetState')
}

export const load = ({ commit, state }, { scan_direction_forward }) => {
  let params = {
    scan_direction_forward,
    max: state.limit
  }

  if (state.minTimestamp) {
    params.exclusive_start_key = {
      group_id: state.group_id,
      create_timestamp: state.minTimestamp
    }
  }

  return feedApi.getFeedByGroupId(state.group_id, params).then(feed => {
    // In case we scrolled to the bottom of the feed, api won't return any items
    if (feed.length > 0) {
      commit('setMinTimestamp', feed[feed.length - 1].create_timestamp)
      commit('addItemsToFeed', feed)

      if (!state.maxTimestamp) {
        commit('setMaxTimestamp', feed[0].create_timestamp)
      }
    }

    return feed
  })
}

export const loadNewItems = ({ commit, state }) => {
  if (!state.maxTimestamp) {
    return false
  }

  let params = {
    scan_direction_forward: true,
    max: state.limit,

    exclusive_start_key: {
      group_id: state.group_id,
      create_timestamp: state.maxTimestamp
    }
  }

  return feedApi.getFeedByGroupId(state.group_id, params).then(newItems => {
    if (newItems.length > 0) {
      commit('setMaxTimestamp', newItems[newItems.length - 1].create_timestamp)
      commit('addNewItems', newItems)
    }

    return newItems
  })
}

export const addNewFeedItem = ({commit}, feed_item) => {
  commit('addNewItems', [feed_item])
}
